<template>
  <div>
    <div class="hvh-flex space-between">
      <h4>{{ text }}</h4>
      <v-btn flat class="hvh-btn hvh-btn--secondary" @click="showAdd = true">Add</v-btn>
    </div>
    <DataTableAsync :data="tableData" v-model="tableState" :length="(data || []).length" noSearch>
      <template #head>
        <tr>
          <Th :prop="idProp" sort>Id</Th>
          <Th prop="name" sort>Name</Th>
          <th class="width-0"></th>
        </tr>
      </template>
      <template #body="{ item }">
        <tr>
          <td>{{ item[idProp] }}</td>
          <td>{{ item.name }}</td>
          <td>
            <v-icon @click="$emit('remove', item)">mdi-close</v-icon>
          </td>
        </tr>
      </template>
    </DataTableAsync>

    <CallPlanningFindTerritories :data="territories" :idProp="idProp" :selected="data" @add="$emit('add', $event)" :text="text" @remove="$emit('remove', $event)" @input="showAdd = false" v-if="showAdd" />
  </div>
</template>

<script>
import DataTableAsync from '../common/dataTable/DataTableAsync.vue';
import Th from '../common/dataTable/Th.vue';
import CallPlanningFindTerritories from './CallPlanningFindTerritories.vue';
export default {
  components: { DataTableAsync, Th, CallPlanningFindTerritories, },
  props: ['data', 'text', 'idProp', 'territories'],
  data() {
    return {
      showAdd: false,
      tableState: { page: 1, perPage: 50 },
    };
  },
  computed: {
    tableData() {
      var response = this.data || [];
      if (this.tableState.sortByProp) {
        var sortFnc = new Function('value', `return value.${this.tableState.sortByProp}`);
        response = response.sortBy(sortFnc);
        if (this.tableState.sortDirection === 'desc')
          response = response.reverse();
      }
      return response
        .skip(this.tableState.perPage * (this.tableState.page - 1))
        .take(this.tableState.perPage);
    },
  }
}
</script>